export const languageCodes = Object.freeze({
  enGB : 'en-GB',
  esES : 'es-ES',
});

export const defaultLanguageCode = languageCodes.enGB;

export const i18nNamespaces = [
  'common', // Keep first as default one
  'board',
];
